const EXPENSE_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  submitted: "Submitted",
  rejected: "Rejected",
  approved: "Approved",
  part_paid: "Part-paid",
  paid: "Paid",
};

const EXPENSE_STATUS_TONES: Record<string, "neutral" | "info" | "success" | "warning" | "danger"> = {
  draft: "neutral",
  submitted: "info",
  rejected: "danger",
  approved: "success",
  part_paid: "warning",
  paid: "success",
};

export function formatExpenseStatus(status: string): string {
  return EXPENSE_STATUS_LABELS[status] ?? status;
}

export function expenseStatusTone(
  status: string,
): "neutral" | "info" | "success" | "warning" | "danger" {
  return EXPENSE_STATUS_TONES[status] ?? "neutral";
}
